"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Media = require("../../Media");

var _PageHeader = _interopRequireDefault(require("./PageHeader"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  body: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0 //        margin: "6em 1em"

  },
  line: {
    position: "absolute",
    zIndex: props => {
      return props.zIndex;
    },
    top: props => {
      return props.top + "%" || "50%";
    },
    right: props => {
      return props.left <= 50 && 100 - props.left + "%" || "0";
    },
    left: props => {
      return props.left > 50 && props.left + "%" || "0";
    },
    height: "2px",
    backgroundColor: "white"
  },
  module: {
    position: "absolute",
    transform: "translateY(-50%)",
    zIndex: props => {
      return props.zIndex;
    },
    top: props => {
      return props.top + "%" || "50%";
    },
    right: props => {
      return props.left > 50 && "0";
    },
    left: props => {
      return props.left <= 50 && "0";
    },
    width: "12em",
    backgroundColor: "white",
    color: "black",
    padding: "1em"
  },
  marker: {
    position: "absolute",
    zIndex: props => {
      return props.zIndex;
    },
    top: props => {
      return props.top + "%" || "50%";
    },
    left: props => {
      return props.left + "%" || "50%";
    }
  },
  border: {
    width: "1.5em",
    height: "1.5em",
    backgroundColor: "white",
    display: "block",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    padding: ".25em"
  },
  label: {
    width: "100%",
    height: "100%",
    backgroundColor: props => {
      return props.color;
    },
    color: "transparent",
    borderRadius: "50%"
  }
}));

const ImagelegendPreview = ({
  formData = {},
  formContext
}) => {
  const locale = formContext && formContext.currentLocale || formContext && formContext.defaultLocale;
  const localeId = "locale:" + locale;
  const onCurrentId = formContext.onCurrentId;
  const contentTitle = formData && formData.content && formData.content.title;
  const title = contentTitle && contentTitle[localeId] || formData.title;
  const classes = useStyles();
  const annotateImage = formData.content && formData.content.backgroundImage;
  const annotateColor = formData.content && formData.content.annotateColor;
  const imageAnnotations = formData && formData.content && formData.content.links;
  const imageFilters = annotateImage && annotateImage.imageFilters;
  const imageUrl = annotateImage && annotateImage.media && annotateImage.media.imageUrl;

  if (!imageUrl) {
    return _react.default.createElement("p", null, "No imageUrl");
  }

  const MarkerModule = (_ref) => {
    let id = _ref.id,
        index = _ref.index,
        _ref$top = _ref.top,
        top = _ref$top === void 0 ? 50 : _ref$top,
        _ref$left = _ref.left,
        left = _ref$left === void 0 ? 50 : _ref$left,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 4 : _ref$size,
        runningHead = _ref.runningHead,
        title = _ref.title,
        description = _ref.description,
        props = _objectWithoutPropertiesLoose(_ref, ["id", "index", "top", "left", "size", "runningHead", "title", "description"]);

    const classes = useStyles({
      size,
      zIndex: index,
      top,
      left
    });
    return _react.default.createElement("div", {
      className: classes.module,
      "data-index": index,
      onClick: () => onCurrentId(id)
    }, runningHead && _react.default.createElement("h3", null, runningHead), _react.default.createElement("h2", null, title), description && _react.default.createElement("p", null, description));
  };

  const MarkerTemplate = (_ref2) => {
    let id = _ref2.id,
        index = _ref2.index,
        _ref2$top = _ref2.top,
        top = _ref2$top === void 0 ? 50 : _ref2$top,
        _ref2$left = _ref2.left,
        left = _ref2$left === void 0 ? 50 : _ref2$left,
        _ref2$size = _ref2.size,
        size = _ref2$size === void 0 ? 4 : _ref2$size,
        props = _objectWithoutPropertiesLoose(_ref2, ["id", "index", "top", "left", "size"]);

    const classes = useStyles({
      size,
      zIndex: index,
      top,
      left,
      color: annotateColor
    });
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
      className: classes.line,
      "data-index": index
    }), _react.default.createElement("div", {
      className: classes.marker,
      onClick: () => onCurrentId(id)
    }, _react.default.createElement("div", {
      className: classes.border
    }, _react.default.createElement("div", {
      className: classes.label
    }, index + 1))));
  };

  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_PageHeader.default, {
    title: title,
    position: "absolute"
  }), _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement(_Media.ImageAnnotationsBase, {
    imageUrl: imageUrl,
    imageFilters: imageFilters,
    imageAnnotations: imageAnnotations,
    overflow: "visible",
    markerTemplate: MarkerTemplate
  }), imageAnnotations && imageAnnotations.map((item, index) => {
    const itemProps = (0, _utils.getPreviewItem)(_extends({}, item, {
      index: index,
      localeId: localeId
    }));
    return _react.default.createElement(MarkerModule, _extends({}, itemProps, {
      key: index
    }));
  })));
};

var _default = ImagelegendPreview;
exports.default = _default;
module.exports = exports.default;